/*
    Create by wyh 2021-07-05
*/
'use strict';
angular.module('historyDraftsModule', [])
    .controller('historyDraftsCtrl', ['$scope', '$q', '$state', '$modalInstance', 'trsHttpService', 'trsspliceString', 'modalDialog', 'editIsLock', 'initSingleSelecet', '$stateParams', '$timeout', 'editingCenterService', 'myManuscriptService',
        function($scope, $q, $state, $modalInstance, trsHttpService, trsspliceString, modalDialog, editIsLock, initSingleSelecet, $stateParams, $timeout, editingCenterService, myManuscriptService) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    // 提交人输入框
                    inputPerson: '',
                    // 提交人初始下拉框数据
                    submitPerson: [],
                    items: []
                };
                $scope.page = { 
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };
                $scope.status = {
                    copyCurrPage: 1,
                    isESSearch: false,
                };
                $scope.params = {
                    serviceid: 'mlf_departoperdoc',
                    methodname: 'quertDeptDocRecords',
                    DeptmentalDocId: $stateParams.departmentDocId, // 部门id
                    PageSize: 20,
                    CurrPage: 1,
                    DocType: '',
                    SubmitUser: '',	// ren.hua@trs.com.cn_60	否	指定提交人
                    StartTime: '', // 2021-06-03 00:00:00	否	最后修改时间开始时间
                    EndTime: ''
                };
                // 类型
                $scope.iWoDocTypes = initSingleSelecet.iDeptDocType();
                $scope.data.selectedDocType = angular.copy($scope.iWoDocTypes[0]);
                // 初始化选择日期
                $scope.timeTypeJsons = initSingleSelecet.iWoOperTime();
                $scope.timeType = angular.copy($scope.timeTypeJsons[0]);
                // 排序方式
                $scope.sortTypeJsons = initSingleSelecet.sortType();
                $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
            }

            /**
             * [initData description]
             * @return {[type]} [description]
             */
            function initData() {
                getDepartPersonList();
                requestData();
            }

            
            /**
             * [getDepartPersonList description] 初始化搜索列表人员
             * @return  {[type]}  [return description]
             */
            function getDepartPersonList() {
                var params = JSON.parse(JSON.stringify($scope.params));
                params.methodname = 'quertDeptDocsSubmitUser';
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.PersonList = data;
                });
            }
            var promise;

            /**
             * [getSuggestions description] 获得输入的请求数据 输入字符串
             * @param   {[String]}  viewValue  [viewValue description]
             * @return  {[type]}             [return description]
             */
            $scope.getSuggestions = function (viewValue) {
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function () {
                    var defer = $q.defer();
    
                    /**
                     * [due description]
                     * @return  {[type]}  [return description]
                     */
                    function due() {
                        if (!$scope.PersonList) {
                            $timeout(() => {
                                due();
                            }, 100);
                        } else {
                            if (viewValue !== '' && !angular.isObject(viewValue)) {
                                $scope.searchParams.Name = viewValue;
                                defer.resolve($scope.PersonList.filter((item) => item.USERNAME.includes(viewValue) === true));
                            } else if (viewValue === '') {
                                if ($scope.params.SubmitUser !== '') {
                                    $scope.queryByDropdown('SubmitUser', '');
                                }
                                defer.resolve($scope.PersonList);
                            }
                        }
                    }
    
                    due();
    
                    return defer.promise;
                }, 100);
                return promise;
            };
            // 监听选择事件返回
            $scope.$on('$typeahead.select', function (event, data) {// 监听在子控制器中定义的 sendParent 事件
                $scope.data.inputPerson = data.USERNAME;
                $scope.queryByDropdown('SubmitUser', data.UNAME);
            });

            /**
             * [reBasePerson description] 提交人选择后回调
             * @param   {[type]}  data  [data description] 回调数据
             * @return  {[type]}        [return description]
             */
            $scope.reBasePerson = function (data) {
                if (data.length === 0) {return;}
                $scope.data.inputPerson = data[0][data[0].length - 1].USERNAME;
                $scope.queryByDropdown('SubmitUser', data[0][data[0].length - 1].UNAME);
            };

            /**
             * [getESSearchParams description]设置ES检索参数
             * @return {[json]} [description] 参数对象
             */
            function getESSearchParams() {
                var esParams = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForIwoDeptDoc',
                    searchParams: {
                        PAGESIZE: $scope.page.PAGESIZE + '',
                        PAGEINDEX: $scope.page.CURRPAGE + '',
                        searchFields: [
                            {
                                searchField: '',
                                keywords: $scope.keywords ? $scope.keywords : '',
                            },
                            {
                                searchField: 'docType',
                                keywords: $scope.params.DocType ? $scope.params.DocType : '',
                            },
                            {
                                searchField: 'submitUser',
                                keywords: $scope.data.inputPerson,
                            },
                            {
                                searchField: 'docStatus',
                                keywords: '',
                            },
                            {
                                searchField: 'timeType',
                                keywords:
                                    angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                        ? $scope.data.fromdate + ',' + $scope.data.untildate
                                        : $scope.timeType.value,
                            },
                            {
                                searchField: '_sort',
                                keywords: $scope.sortType.value,
                            },
                        ],
                    },
                    DeptmentalDocId: $stateParams.departmentDocId,
                    MediaType: -2,
                    status: -1
                };
                esParams.searchParams = JSON.stringify(esParams.searchParams);
                return esParams;
            }

            /**
             * [requestDepartsList description] 初始化部门列表
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.items = data.DATA;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                });
            }

            /**
             * [fullTextSearch description]检索
             * @param   {[type]}  ev  [ev description]
             * @return  {[type]}      [return description]
             */
            $scope.fullTextSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.status.isESSearch = true;
                    $scope.page.CURRPAGE = 1;
                    requestData();
                }
            };

            /**
             * [queryByDropdown description] 筛选条件触发后请求数据
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function (key, value) {
                $scope.params[key] = value;
                $scope.params.CurrPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
                if (key === 'OperTime') {
                    // 部门稿库日期特殊处理 --start
                    var startDate = $scope.data.fromdate === '' ? '' : $scope.data.fromdate + ' 00:00:00';
                    var endDate = $scope.data.untildate === '' ? '' : $scope.data.untildate + ' 23:59:59';
                    // 部门稿库日期特殊处理 --end
                    $scope.params.StartTime = startDate;
                    $scope.params.EndTime = endDate;
                    $scope.params[key] = null;
                }
                if (key === 'DocType' && value === '2') {
                    $scope.status.hasphotoflag = true;
                }
                requestData();
            };

            /**
             * [pageChanged description]下一页
             *
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description]跳转到指定页面
             * @return  {[type]}  [return description]
             */
            $scope.jumpToPage = function () {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };

            /**
             * [selectPageNum description]选择单页显示个数
             * @return {[type]} [description] null
             */
            $scope.selectPageNum = function () {
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.page.CURRPAGE = 1;
                requestData();
            };

            /**
             * [showVersionTime description]流程版本时间与操作日志
             * @param   {[type]}  item  [item description]稿件对象
             * @return  {[type]}        [return description]
             */
            $scope.showVersionTime = function (item) {
                editingCenterService.getVersionTime(item, false);
            };

            /**
             * [fusionPreview description] 融合编辑 预览
             * @param   {[Object]}  item    [item description] 稿件对象 
             * @return  {[type]}            [return description]
             */
            $scope.fusionPreview = function (item) {
                myManuscriptService.fusionPreviewRouter(item, $scope);
            };

            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
